import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import locationImportsService from "../../services/locationImportsService";

export const useGetCSVImport = (queryOptions = {}) => {
  return useQuery(["currentImport"], locationImportsService.get, {
    ...queryOptions,
    cacheTime: 0,
  });
};

export const useCreateCSVImport = (mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation(locationImportsService.create, {
    ...mutationOptions,
    onSuccess: (data) => {
      queryClient.setQueryData(["currentImport"], data);
      mutationOptions.onSuccess(data);
    },
  });
};

export const useDestroyCSVImport = (mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation(locationImportsService.delete, {
    ...mutationOptions,
    onSuccess: (data) => {
      console.log("Destroy CSV Import mutation success:", data);
      queryClient.removeQueries({ queryKey: ["currentImport"], exact: true });
      mutationOptions.onSuccess && mutationOptions.onSuccess(data);
    },
    onError: (error) => {
      console.error("Destroy CSV Import mutation error:", error);
      mutationOptions.onError && mutationOptions.onError(error);
    }
  });
};
